import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelText as _vModelText, vShow as _vShow, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "team-option" }
const _hoisted_3 = { class: "select-list" }
const _hoisted_4 = ["onUpdate:modelValue", "onChange"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 0,
  class: "supporter"
}
const _hoisted_7 = { class: "left" }
const _hoisted_8 = ["id", "onUpdate:modelValue"]
const _hoisted_9 = ["for"]
const _hoisted_10 = { class: "character" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "tooltip" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["disabled", "onClick"]
const _hoisted_16 = {
  key: 0,
  class: "builddata-selector"
}
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "equipment" }
const _hoisted_20 = { class: "with-tooltip" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "tooltip" }
const _hoisted_23 = { class: "with-tooltip" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "tooltip" }
const _hoisted_26 = { class: "with-tooltip" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "tooltip" }
const _hoisted_29 = ["onUpdate:modelValue", "disabled", "onChange"]
const _hoisted_30 = ["onUpdate:modelValue", "disabled", "onChange"]
const _hoisted_31 = ["value"]
const _hoisted_32 = ["onUpdate:modelValue", "min", "max", "step", "disabled", "onBlur"]
const _hoisted_33 = ["id", "onUpdate:modelValue"]
const _hoisted_34 = ["for"]
const _hoisted_35 = { class: "character" }
const _hoisted_36 = ["src", "alt"]
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "tooltip" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["disabled", "onClick"]
const _hoisted_41 = { class: "option-description" }
const _hoisted_42 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return true
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("fieldset", _hoisted_2, [
          _createElementVNode("legend", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSwitch = !_ctx.toggleSwitch))
          }, "  " + _toDisplayString(_ctx.displayName("サポーター")) + "  ", 1),
          _createElementVNode("div", null, [
            _createElementVNode("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elementList, (item) => {
                return (_openBlock(), _createElementBlock("li", { key: item }, [
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      class: "hidden",
                      type: "checkbox",
                      "onUpdate:modelValue": ($event: any) => ((_ctx.elementCheckList[item]) = $event),
                      onChange: ($event: any) => (_ctx.checkListOnChange(item, _ctx.elementCheckList))
                    }, null, 40, _hoisted_4), [
                      [_vModelCheckbox, _ctx.elementCheckList[item]]
                    ]),
                    _createElementVNode("img", {
                      class: "filter",
                      src: _ctx.elementSrc(item),
                      alt: item
                    }, null, 8, _hoisted_5)
                  ])
                ]))
              }), 128))
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SUPPORTER_KEY_LIST, (supporter) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: supporter }, [
              (_ctx.supporterOpenClose[supporter])
                ? _withDirectives((_openBlock(), _createElementBlock("fieldset", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", {
                        class: _normalizeClass('supporter' + _ctx.supporterOptionSelectedClass(supporter))
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          class: "hidden",
                          id: 'supporter-' + supporter,
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.supporterOpenClose[supporter]) = $event)
                        }, null, 8, _hoisted_8), [
                          [_vModelCheckbox, _ctx.supporterOpenClose[supporter]]
                        ]),
                        _createElementVNode("label", {
                          class: "fold with-tooltip",
                          for: 'supporter-' + supporter
                        }, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("img", {
                              class: "character",
                              src: _ctx.characterIconSrc(supporter),
                              alt: _ctx.displayName(supporter)
                            }, null, 8, _hoisted_11),
                            _createElementVNode("img", {
                              class: "vision",
                              src: _ctx.characterVisionIconSrc(supporter),
                              alt: "vision"
                            }, null, 8, _hoisted_12)
                          ]),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.displayName(supporter)), 1)
                        ], 8, _hoisted_9),
                        (_ctx.teamMembers.includes(supporter))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              onClick: ($event: any) => (_ctx.removeFromTeamOnClick(supporter))
                            }, _cache[5] || (_cache[5] = [
                              _createElementVNode("span", { class: "material-symbols-outlined remove" }, " person_remove ", -1)
                            ]), 8, _hoisted_14))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              disabled: _ctx.teamMembers.length >= 3,
                              onClick: ($event: any) => (_ctx.addToTeamOnClick(supporter))
                            }, _cache[6] || (_cache[6] = [
                              _createElementVNode("span", { class: "material-symbols-outlined add" }, " person_add ", -1)
                            ]), 8, _hoisted_15))
                      ], 2),
                      (_ctx.buildnameList(supporter).length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("label", null, [
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": ($event: any) => ((_ctx.selectedBuildname[supporter]) = $event),
                                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.buildnameSelectionOnChange && _ctx.buildnameSelectionOnChange(...args)))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buildnameList(supporter), (item) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: item,
                                    key: item
                                  }, _toDisplayString(item), 9, _hoisted_18))
                                }), 128))
                              ], 40, _hoisted_17), [
                                [_vModelSelect, _ctx.selectedBuildname[supporter]]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("img", {
                            src: _ctx.weaponIconSrc(supporter),
                            alt: "weapon"
                          }, null, 8, _hoisted_21),
                          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.weaponName(supporter)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("img", {
                            src: _ctx.artifactSetIconSrc(supporter, 0),
                            alt: "artifact set"
                          }, null, 8, _hoisted_24),
                          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.artifactSetName(supporter, 0)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("img", {
                            src: _ctx.artifactSetIconSrc(supporter, 1),
                            alt: "artifact set"
                          }, null, 8, _hoisted_27),
                          _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.artifactSetName(supporter, 1)), 1)
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supporterCheckboxList(supporter), (item) => {
                        return (_openBlock(), _createElementBlock("label", {
                          class: "condition",
                          key: item.name
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((_ctx.conditionValues[item.name]) = $event),
                            disabled: _ctx.conditionDisabled(item),
                            onChange: ($event: any) => (_ctx.valueOnChange($event, item))
                          }, null, 40, _hoisted_29), [
                            [_vModelCheckbox, _ctx.conditionValues[item.name]]
                          ]),
                          _createElementVNode("span", null, _toDisplayString(_ctx.displayName(item.displayName)), 1)
                        ]))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supporterSelectList(supporter), (item) => {
                        return (_openBlock(), _createElementBlock("label", {
                          class: "condition",
                          key: item.name
                        }, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.displayName(item.displayName)), 1),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": ($event: any) => ((_ctx.conditionValues[item.name]) = $event),
                            disabled: _ctx.conditionDisabled(item),
                            onChange: ($event: any) => (_ctx.valueOnChange($event, item))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (option, index) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: index,
                                key: option
                              }, _toDisplayString(_ctx.displayOptionName(option)), 9, _hoisted_31))
                            }), 128))
                          ], 40, _hoisted_30), [
                            [_vModelSelect, _ctx.conditionValues[item.name]]
                          ])
                        ]))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supporterNumberList(supporter), (item) => {
                        return (_openBlock(), _createElementBlock("label", {
                          class: "condition",
                          key: item.name
                        }, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.displayName(item.displayName)), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => ((_ctx.conditionValues[item.name]) = $event),
                            min: item.min,
                            max: item.max,
                            step: item.step,
                            disabled: _ctx.conditionDisabled(item),
                            onBlur: ($event: any) => (_ctx.valueOnChange($event, item))
                          }, null, 40, _hoisted_32), [
                            [_vModelText, _ctx.conditionValues[item.name]]
                          ])
                        ]))
                      }), 128))
                    ])
                  ], 512)), [
                    [_vShow, _ctx.supporterVisible(supporter)]
                  ])
                : _withDirectives((_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass('supporter-else' + _ctx.elementBgClass(supporter) + _ctx.supporterOptionSelectedClass(supporter))
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "hidden",
                      id: 'supporter-else-' + supporter,
                      type: "checkbox",
                      "onUpdate:modelValue": ($event: any) => ((_ctx.supporterOpenClose[supporter]) = $event)
                    }, null, 8, _hoisted_33), [
                      [_vModelCheckbox, _ctx.supporterOpenClose[supporter]]
                    ]),
                    _createElementVNode("label", {
                      class: "fold with-tooltip",
                      for: 'supporter-else-' + supporter
                    }, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("img", {
                          class: "character",
                          src: _ctx.characterIconSrc(supporter),
                          alt: _ctx.displayName(supporter)
                        }, null, 8, _hoisted_36),
                        _createElementVNode("img", {
                          class: "vision",
                          src: _ctx.characterVisionIconSrc(supporter),
                          alt: "vision"
                        }, null, 8, _hoisted_37)
                      ]),
                      _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.displayName(supporter)), 1)
                    ], 8, _hoisted_34),
                    (_ctx.teamMembers.includes(supporter))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          onClick: ($event: any) => (_ctx.removeFromTeamOnClick(supporter))
                        }, _cache[7] || (_cache[7] = [
                          _createElementVNode("span", { class: "material-symbols-outlined remove" }, " person_remove ", -1)
                        ]), 8, _hoisted_39))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          disabled: _ctx.teamMembers.length >= 3,
                          onClick: ($event: any) => (_ctx.addToTeamOnClick(supporter))
                        }, _cache[8] || (_cache[8] = [
                          _createElementVNode("span", { class: "material-symbols-outlined add" }, " person_add ", -1)
                        ]), 8, _hoisted_40))
                  ], 2)), [
                    [_vShow, _ctx.supporterVisible(supporter)]
                  ])
            ], 64))
          }), 128)),
          _cache[9] || (_cache[9] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("ul", _hoisted_41, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayStatAjustmentList, (item) => {
              return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
            }), 128))
          ]),
          _createElementVNode("label", null, [
            _createTextVNode(_toDisplayString(_ctx.displayName("すべて閉じる")) + " ", 1),
            _createElementVNode("button", {
              class: "execute",
              type: "button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeAllSupporters && _ctx.closeAllSupporters(...args)))
            }, _toDisplayString(_ctx.displayName("実行")), 1)
          ]),
          _createElementVNode("label", null, [
            _createTextVNode(_toDisplayString(_ctx.displayName("すべてクリア")) + " ", 1),
            _createElementVNode("button", {
              class: "execute",
              type: "button",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearAllSupporterOptions && _ctx.clearAllSupporterOptions(...args)))
            }, _toDisplayString(_ctx.displayName("実行")), 1)
          ])
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("p", { class: "notice" }, [
          _createTextVNode(" キャラクターの天賦レベルやステータスによって効果量が変動する種類のオプションはデフォルト名称の構成保存データが存在する場合に選択可能になります。 "),
          _createElementVNode("br"),
          _createTextVNode(" 構成保存データのデフォルト名称：あなたの{キャラクターの名前} ")
        ], -1))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_42, [
        _createElementVNode("label", {
          class: "closed",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleSwitch = !_ctx.toggleSwitch))
        }, _toDisplayString('+ ' + _ctx.displayName("サポーター") + '+ '), 1)
      ]))
}